// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */

import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import { sync } from 'vuex-router-sync';
import '@modernizr';

import App from './App';
import router from './router';
import store from './store';

import { getRandom } from './scripts/utils';
/* eslint-enable */

var events = [];

if ((window.chrome && window.chrome.webstore)) {
  events = ['mousewheel', 'resize', 'touchmove'];
} else {
  events = ['mousewheel', 'resize', 'touchmove', 'scroll', 'wheel'];
}

Vue.use(VueLazyload, {
  listenEvents: events,
});

Vue.config.productionTip = false;
sync(store, router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});


var bg = [
  'background: linear-gradient(135deg, rgba(18, 23, 255, 1) 0%, rgba(30, 30, 30, 1) 100%);',
  'color: white',
  'padding: 5px 20px',
  'line-height: 25px',
].join(';');
console.log('%cOWOF | Join the treasure hunt! We placed a couple candies here and there. Can you find them?', bg);

var title = document.title;
// change title
window.addEventListener('blur', function() {
  var texts = [
    'Going already?',
    'Checking Facebook?',
    'Tweeting #owof?',
    'Who is it?',
    'Farewell!',
    'Until next time!',
    'Lets walk you out.',
  ];
  var number = getRandom(0, (texts.length - 1));

  title = document.title;
  document.title = texts[number];
});

window.addEventListener('focus', function() {
  document.title = title;
});



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 268
// module chunks = 3